import { render, staticRenderFns } from "./RfidAuthorizedAppUsers.vue?vue&type=template&id=010dc736&lang=pug&"
import script from "./RfidAuthorizedAppUsers.vue?vue&type=script&lang=ts&"
export * from "./RfidAuthorizedAppUsers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports